import { Icon } from '@iconify/react'
import React, { useState } from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom'
import config from '../config'

const ResetPasswordLayer = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        if (password !== confirmPassword) {
            setError("Passwords do not match");
            setLoading(false);
            return;
        }

        if (password.length < 6) {
            setError("Password must be at least 6 characters");
            setLoading(false);
            return;
        }

        try {
            const response = await fetch(`${config.API_BASE_URL}/api/auth/reset-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, password })
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'Reset failed');

            setSuccess(true);
            setTimeout(() => {
                navigate('/sign-in');
            }, 3000);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    if (success) {
        return (
            <section className="auth bg-base d-flex flex-wrap">
                <div className="auth-left d-lg-block d-none">
                    <div className="d-flex align-items-center flex-column h-100 justify-content-center">
                         <img src="/assets/images/auth/forgot-pass-img.png" alt="" />
                    </div>
                </div>
                <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
                    <div className="max-w-464-px mx-auto w-100 text-center">
                        <div className="mb-32">
                            <Icon icon="teenyicons:tick-circle-solid" className="text-success text-6xl" width="64" height="64" />
                        </div>
                        <h6 className="mb-12">Password Reset Successful</h6>
                        <p className="text-secondary-light text-sm mb-0">
                            Your password has been successfully reset. <br />
                            Redirecting to login page...
                        </p>
                        <Link to="/sign-in" className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32">
                            Go to Sign In Now
                        </Link>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="auth bg-base d-flex flex-wrap">
            <div className="auth-left d-lg-block d-none">
                <div className="d-flex align-items-center flex-column h-100 justify-content-center">
                    <img src="/assets/images/auth/forgot-pass-img.png" alt="" />
                </div>
            </div>
            <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
                <div className="max-w-464-px mx-auto w-100">
                    <div>
                        <h4 className="mb-12">Set New Password</h4>
                        <p className="mb-32 text-secondary-light text-lg">
                            Please create a new password that you don't use on any other site.
                        </p>
                    </div>
                    {error && (
                        <div className="alert alert-danger mb-3" role="alert">
                            {error}
                        </div>
                    )}
                    <form onSubmit={handleSubmit}>
                        {/* New Password */}
                        <div className="mb-20">
                            <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                New Password
                            </label>
                            <div className="position-relative">
                                <div className="icon-field">
                                    <span className="icon top-50 translate-middle-y">
                                        <Icon icon="solar:lock-password-outline" />
                                    </span>
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        className="form-control h-56-px bg-neutral-50 radius-12"
                                        placeholder="Password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                </div>
                                <span
                                    className={`toggle-password ${showPassword ? 'ri-eye-line' : 'ri-eye-off-line'} cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                                    onClick={() => setShowPassword(!showPassword)}
                                />
                            </div>
                        </div>

                        {/* Confirm Password */}
                        <div className="mb-20">
                            <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                Confirm Password
                            </label>
                            <div className="position-relative">
                                <div className="icon-field">
                                    <span className="icon top-50 translate-middle-y">
                                        <Icon icon="solar:lock-password-outline" />
                                    </span>
                                    <input
                                        type={showConfirmPassword ? 'text' : 'password'}
                                        className="form-control h-56-px bg-neutral-50 radius-12"
                                        placeholder="Confirm Password"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        required
                                    />
                                </div>
                                <span
                                    className={`toggle-password ${showConfirmPassword ? 'ri-eye-line' : 'ri-eye-off-line'} cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                />
                            </div>
                        </div>

                        <button
                            type="submit"
                            className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
                            disabled={loading}
                        >
                            {loading ? 'Resetting...' : 'Reset Password'}
                        </button>
                    </form>
                </div>
            </div>
        </section>
    )
}

export default ResetPasswordLayer
